import type { TIconProps } from "./types";

export const GitHub = (props: TIconProps) => {
  return (
    <svg
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        clipPath="url(#clip0_173_50184)"
        className="[--github-icon-fill:#24292F] dark:[--github-icon-fill:#EDEAEF]"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.6912 0.0366211C4.99336 0.0366211 0.387207 4.61006 0.387207 10.268C0.387207 14.7907 3.33853 18.6191 7.43279 19.9741C7.94468 20.076 8.13218 19.754 8.13218 19.4831C8.13218 19.2459 8.11531 18.4329 8.11531 17.5857C5.24899 18.1957 4.6521 16.3661 4.6521 16.3661C4.19146 15.1803 3.50894 14.8756 3.50894 14.8756C2.5708 14.2488 3.57728 14.2488 3.57728 14.2488C4.61793 14.3166 5.16399 15.299 5.16399 15.299C6.08505 16.8573 7.56925 16.417 8.16635 16.1459C8.25156 15.4853 8.52469 15.0279 8.8147 14.7739C6.5286 14.5367 4.12334 13.6559 4.12334 9.72587C4.12334 8.60787 4.53251 7.69318 5.18086 6.9818C5.07857 6.72777 4.72022 5.67734 5.28336 4.27142C5.28336 4.27142 6.15338 4.00034 8.1151 5.32165C8.95497 5.09769 9.82113 4.98376 10.6912 4.9828C11.5612 4.9828 12.4481 5.1015 13.2671 5.32165C15.229 4.00034 16.099 4.27142 16.099 4.27142C16.6622 5.67734 16.3036 6.72777 16.2013 6.9818C16.8668 7.69318 17.2591 8.60787 17.2591 9.72587C17.2591 13.6559 14.8538 14.5197 12.5506 14.7739C12.926 15.0957 13.25 15.7054 13.25 16.6711C13.25 18.0431 13.2331 19.1442 13.2331 19.4829C13.2331 19.754 13.4208 20.076 13.9325 19.9743C18.0268 18.6189 20.9781 14.7907 20.9781 10.268C20.995 4.61006 16.372 0.0366211 10.6912 0.0366211Z"
          fill="var(--github-icon-fill)"
        />
      </g>
      <defs>
        <clipPath id="clip0_173_50184">
          <rect
            width={20.6696}
            height={19.9568}
            fill="white"
            transform="translate(0.387207 0.0366211)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
